import React, { useEffect, useState } from "react";

export default function RoyalKidzPodacastPrivacyPolicy() {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchPDF = async () => {
            try {
                const url = "https://firebasestorage.googleapis.com/v0/b/academic-haven-site.appspot.com/o/RoyalKidz_Privacy_Policy_Branded.pdf?alt=media&token=6ab90df3-2401-47a5-89f9-08477fb52fa9";
                setPdfUrl(url);
            } catch (error) {
                console.error("Error loading PDF:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPDF();
    }, []);

    if (loading) return <p style={{ textAlign: "center" }}>Loading Privacy Policy…</p>;

    if (!pdfUrl) {
        return <p style={{ color: "red", textAlign: "center" }}>Unable to load document.</p>;
    }

    return (
        <div style={{ width: "100%", height: "100vh" }}>
            <embed
                src={pdfUrl}
                type="application/pdf"
                style={{ width: "100%", height: "100%" }}
            />
            <p style={{ textAlign: "center", marginTop: 8 }}>
                If the document doesn’t display,
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer"> download it here</a>.
            </p>
        </div>
    );
}